import React, { Component } from "react";
import Button from './Button'
import './style.css'
import Konva from "konva"
import Hammer from 'react-hammerjs';
import axios from "axios";
class ReactKrishViewer extends Component {


    constructor() {
        super();
        this.imageContainerRef = React.createRef();
        this.viewPercentageRef = React.createRef();
        this.viewPortElementRef = React.createRef();
        this.canvas = null
        this.ctx = null
        this.isMobile = false
        this.imageData = []
        this.images = []
        this.imagesWithID = {}
        this.imagesWithVisible = {}
        this.imagesWithImage = {}
        this.imagesIn = null
        this.commonAttrs = {}
        this.loadedImages = 0
        this.viewerPercentage = null
        this.currentImage = null
        this.currentLeftPosition = this.currentTopPosition = 0
        this.currentCanvasImage = null
        this.centerX = 0
        this.centerY = 0
        this.movementStart = 0
        this.movement = false
        this.speedFactor = 13
        this.activeImage = 1
        this.stopAtEdges = false
        this.SCALE = 0.1;
        this.OFFSET = 80;
        this.layer = null;
        this.layer1 = null;
        this.stage = null;
        this.isActivated = false;
        this.fixedWidth = 1920.0;
        this.fixedHeight = 1080.0;

        this.state = {
            lastX: 0,
            lastY: 0,
            minScale: 0.5,
            maxScale: 4,
            scale: 0.2,
            customOffset: 10,
            currentScale: 1,
            currentTopPosition: 0,
            currentLeftPosition: 0,
            selectMenuOption: 1,
            currentImage: null,
            dragging: false,
            canvas: null,
            ctx: null,
            dragStart: null,
            currentCanvasImage: null,
            isFullScreen: false,
            viewPortElementWidth: null,
            movementStart: 0,
            movement: false,
            dragSpeed: 150,
            speedFactor: 13,
            activeImage: 1,
            stopAtEdges: false,
            panmode: false,
            imagesIn: null,
            imagesWithID: {},
            imagesWithVisible: {},
            imagesWithImage: {},
            commonAttrs: {},
            currentLoop: 0,
            loopTimeoutId: 0,
            playing: false,
            imagesLoaded: false,
            isActivated: false,
            fixedWidth: 1920.0,
            ixedHeight: 1080.0,
            stage: null
        }

        //this.currentLeftPosition = this.currentLeftPosition.bind(this)
    }

    componentDidMount() {
        const isFirstLoad = localStorage.getItem('isReactKrishViewerFirstLoad');
        this.disableZoomin()
        const isChromeOnIOS =
            /CriOS/.test(navigator.userAgent) && /iPad|iPhone|iPod/.test(navigator.platform);

        if (isChromeOnIOS) {
            window.addEventListener("orientationchange", this.handleOrientationChange);
        }
        this.viewerPercentage = this.viewPercentageRef.current;
        this.viewPortElementRef = this.viewerContainerRef.getElementsByClassName('v360-viewport-container')[0]
        this.fetchData()
        if (!this.state.imagesLoaded) {
            // Images are not loaded, fetch and preload them
            this.fetchData();
        }
    }

    handleOrientationChange = () => {
        // Reload the page on orientation change
        window.location.reload();
    };
    fetchData() {
        for (let i = 1; i <= this.props.amount; i++) {
            const imageIndex = (this.props.paddingIndex) ? this.lpad(i, "0", 2) : i
            const fileName = this.props.fileName.replace('{index}', imageIndex);
            const uniqueParam = `?timestamp=${new Date().getTime()}`;
            const filePath = `${this.props.imagePath}/${fileName}${uniqueParam}`;
            this.imageData.push(filePath)
        }

        this.preloadImages()
    }

    lpad(str, padString, length) {
        str = str.toString()
        while (str.length < length) str = padString + str
        return str
    }

    getValueForKey(key, arr) {
        var val = ''
        arr.forEach(ele => {
            if (ele.split(':')[0] === key) {
                val = ele.split(':')[1]
                return
            }
        })
        return val
    }
    async fetchInteriorImage(image) {
        try {
            const res = await axios.get(image)
            const parser = new DOMParser();
            const svg = parser.parseFromString(res.data, 'image/svg+xml');
            // this.handleSvgLoad(svg);
            var paths = Array.prototype.slice.call(svg.getElementsByTagName('path')); // copies elements, creates array
            const style = paths[0].getAttribute('style').split(';')
            this.commonAttrs =
            {
                'sf': this.getValueForKey('fill', style),
                'ss': this.getValueForKey('stroke', style),
                'ssw': this.getValueForKey('stroke-width', style)
            }
        } catch (error) {
        }
    };
    async fetchInteriorImageLoop(image) {
        try {
            const res = await axios.get(image)
            const parser = new DOMParser();
            const svg = parser.parseFromString(res.data, 'image/svg+xml');
            // this.handleSvgLoad(svg);
            var paths = Array.prototype.slice.call(svg.getElementsByTagName('path')); // copies elements, creates array
            paths.forEach(path => {
                const id = path.getAttribute('id')
                if (this.imagesWithID[image] == undefined) {
                    this.imagesWithID[image] = {}
                }
                this.imagesWithID[image][id] = path.getAttribute('d')
                this.imagesWithVisible[id] = true
                this.imagesWithVisible[id + '-select'] = false
                this.imagesWithVisible[id + '-color'] = this.getValueForKey('fill', path.getAttribute('style').split(';'))
                this.imagesWithVisible[id + '-coloro'] = .6//parseFloat(this.getValueForKey('fill-opacity',path.getAttribute('style').split(';')))
                // this.imagesWithVisible[id + '-colorStroke'] = "#fff"//parseFloat(this.getValueForKey('fill-opacity',path.getAttribute('style').split(';')))
                // this.imagesWithVisible[id + '-colorWidth'] = "3"
            })
        } catch (error) {
        }
    };
    handleSvgLoad(svg) {
        // Perform actions after SVG is loaded, e.g., update state or redraw
        // For example, you can call a method to redraw the canvas or update the state
        this.redraw();
    }
    preloadImages() {
        if (this.imageData.length) {
            try {
                //this.props.amount = this.imageData.length;
                this.fetchInteriorImage("assets/" + this.imageData[0].replace('.jpg', '.svg').split("assets/").pop())
                this.imageData.forEach(src => {
                    this.addImage(src);
                    this.fetchInteriorImageLoop("assets/" + src.replace('.jpg', '.svg').split("assets/").pop())
                });
            } catch (error) {
                console.error(`Something went wrong while loading images: ${error.message}`);
            }
        } else {
        }
    }

    addImage(resultSrc) {
        const image = new Image();
        image.src = resultSrc;
        //image.crossOrigin='anonymous'
        image.onload = this.onImageLoad.bind(this);
        image.onerror = this.onImageLoad.bind(this);
        this.images.push(image);
    }

    onImageLoad(event) {
        const percentage = Math.round(this.loadedImages / this.props.amount * 100);
        this.loadedImages += 1;
        this.updatePercentageInLoader(Math.min(percentage, 100));
        if (this.loadedImages === this.props.amount) {
            this.onAllImagesLoaded(event);
        } else if (this.loadedImages === 1) {
        }
        // this.reloadSVG();
    }

    updatePercentageInLoader(percentage) {
        this.viewerPercentage.innerHTML = percentage + '%';
    }

    onAllImagesLoaded(e) {
        this.setState({ imagesLoaded: true })
        this.initData()
    }
    logs(e) {
    }

    initData() {
        this.canvas = this.imageContainerRef
        this.logs(this.canvas)
        this.ctx = this.canvas.getContext('2d')
        this.attachEvents();
        this.checkMobile()
        this.loadInitialImage()
        this.stage = new Konva.Stage({
            container: 'canvas1',
            width: window.innerWidth,
            height: window.innerHeight
        });
        this.layer1 = new Konva.Layer();
        this.layer1.clearBeforeDraw(true)
        this.stage.add(this.layer1)
        this.setState({ playing: this.props.autoplay })
        window.addEventListener("resize", (e) => {
            this.resizeWindow()
        });
        this.resizeWindow()

    }
    resizeWindow() {
        const MAX_HEIGHT = 1080;
        const MAX_WIDTH = 1920;
        const w = window.innerWidth
        const h = window.innerHeight

        const mr = MAX_WIDTH / MAX_HEIGHT
        const ar = w / h
        var tarW = MAX_WIDTH
        var tarH = MAX_HEIGHT
        var scalex = 0, scaley = 0

        if (mr < ar) {
            tarW = h * (MAX_WIDTH / MAX_HEIGHT)
            tarH = h
            scalex = tarW / MAX_WIDTH
        } else {
            tarW = w
            tarH = w * (MAX_HEIGHT / MAX_WIDTH)
            scalex = tarW / MAX_WIDTH
        }
        var x = 0, y = 0
        if (window.innerHeight > tarH) {
            y = (window.innerHeight - tarH) / 2.0
        }
        if (window.innerWidth > tarW) {
            x = (window.innerWidth - tarW) / 2.0
        }
        this.stage.setX(x);
        this.stage.setY(y);

        this.stage.setWidth(x + tarW);
        this.stage.setHeight(y + tarH);
        this.stage.scale({ x: scalex, y: scalex })

    }

    attachEvents() {
        if (this.state.panmode) {
            this.bindPanModeEvents()
        } else {
            this.bind360ModeEvents()
        }
    }

    bindPanModeEvents() {
        this.viewPortElementRef.removeEventListener('touchend', this.touchEnd);
        this.viewPortElementRef.removeEventListener('touchstart', this.touchStart);
        this.viewPortElementRef.removeEventListener('touchmove', this.touchMove);

        this.viewPortElementRef.addEventListener('touchend', this.stopDragging);
        this.viewPortElementRef.addEventListener('touchstart', this.startDragging);
        this.viewPortElementRef.addEventListener('touchmove', this.doDragging);

        this.viewPortElementRef.removeEventListener('mouseup', this.stopMoving);
        this.viewPortElementRef.removeEventListener('mousedown', this.startMoving);
        this.viewPortElementRef.removeEventListener('mousemove', this.doMoving);
        this.viewPortElementRef.removeEventListener('mouseout', this.leaveArea);
        window.removeEventListener('resize', this.resize);

        this.viewPortElementRef.addEventListener('mouseup', this.stopDragging);
        this.viewPortElementRef.addEventListener('mousedown', this.startDragging);
        this.viewPortElementRef.addEventListener('mousemove', this.doDragging);
        this.viewPortElementRef.addEventListener('mouseout', this.leaveArea);
        window.addEventListener('resize', this.resize);
    }

    bind360ModeEvents() {
        this.viewPortElementRef.removeEventListener('touchend', this.stopDragging);
        this.viewPortElementRef.removeEventListener('touchstart', this.startDragging);
        this.viewPortElementRef.removeEventListener('touchmove', this.doDragging);

        this.viewPortElementRef.addEventListener('touchend', this.touchEnd);
        this.viewPortElementRef.addEventListener('touchstart', this.touchStart);
        this.viewPortElementRef.addEventListener('touchmove', this.touchMove);

        this.viewPortElementRef.removeEventListener('mouseup', this.stopDragging);
        this.viewPortElementRef.removeEventListener('mousedown', this.startDragging);
        this.viewPortElementRef.removeEventListener('mousemove', this.doDragging);
        this.viewPortElementRef.removeEventListener('mouseout', this.leaveArea);
        window.removeEventListener('resize', this.resize);

        this.viewPortElementRef.addEventListener('mouseup', this.stopMoving);
        this.viewPortElementRef.addEventListener('mousedown', this.startMoving);
        this.viewPortElementRef.addEventListener('mousemove', this.doMoving);
        this.viewPortElementRef.addEventListener('mouseout', this.leaveArea);
        window.addEventListener('resize', this.resize);
    }

    startDragging = (evt) => {
        this.dragging = true
        document.body.style.mozUserSelect = document.body.style.webkitUserSelect = document.body.style.userSelect = 'none';
        this.setLastPositions(evt)

        this.dragStart = this.ctx.transformedPoint(this.state.lastX, this.state.lastY);
    }

    setLastPositions(evt) {
        if (this.isMobile) {
            this.setState({
                lastX: evt.touches[0].offsetX || (evt.touches[0].pageX - this.canvas.offsetLeft),
                lastY: evt.touches[0].offsetY || (evt.touches[0].pageY - this.canvas.offsetTop)
            })
        } else {
            this.setState({
                lastX: evt.offsetX || (evt.pageX - this.canvas.offsetLeft),
                lastY: evt.offsetY || (evt.pageY - this.canvas.offsetTop)
            })
        }
    }

    leaveArea = (evt) => {
        this.stopMoving()
    }
    resize = (sz) => {
        var container = document.querySelector('#stage-parent');


    }
    doDragging = (evt) => {

        this.setLastPositions(evt)

        if (this.dragStart) {
            let pt = this.ctx.transformedPoint(this.state.lastX, this.state.lastY);
            this.ctx.translate(pt.x - this.dragStart.x, pt.y - this.dragStart.y);
            //redraw();
            this.redraw();
        }
    }

    stopDragging = (evt) => {
        this.dragging = false
        this.dragStart = null
    }

    checkMobile() {
        this.isMobile = !!('ontouchstart' in window || navigator.msMaxTouchPoints);
    }

    loadInitialImage() {
        this.currentImage = this.imageData[0]
        this.setImage()
    }

    setImage(cached = false) {
        this.currentLeftPosition = this.currentTopPosition = 0

        if (!cached) {
            this.currentCanvasImage = new Image()
            this.currentCanvasImage.crossOrigin = 'anonymous'
            this.currentCanvasImage.src = this.currentImage

            this.currentCanvasImage.onload = () => {
                let viewportElement = this.viewPortElementRef.getBoundingClientRect()
                this.canvas.width = (this.state.isFullScreen) ? viewportElement.width : this.currentCanvasImage.width
                this.canvas.height = (this.state.isFullScreen) ? viewportElement.height : this.currentCanvasImage.height
                this.trackTransforms(this.ctx)
                this.redraw()
            }
            this.currentCanvasImage.onerror = () => {
            }
        } else {
            this.currentCanvasImage = this.images[0]
            let viewportElement = this.viewPortElementRef.getBoundingClientRect()
            this.canvas.width = (this.state.isFullScreen) ? viewportElement.width : this.currentCanvasImage.width
            this.canvas.height = (this.state.isFullScreen) ? viewportElement.height : this.currentCanvasImage.height
            this.trackTransforms(this.ctx)
            this.redraw()
        }

    }

    getIDOf(object, value) {
        var val = null
        object.map((row, index) => {
            if (row['id'] == value) {
                val = row
            }
        })
        return val
    }
    getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    showItem(self, ev, val = true) {
        this.imagesWithVisible[ev] = val
        let item = this.layer1.find('.' + ev)
        if (item.length > 0) {
            this.redrawItem(item[0])
        }
    }
    // reloadSVG = () => {
    //     const imageName = this.images[this.activeImage - 1].getAttribute('src').replace('.jpg', '.svg').split("/assets/").pop();
    //     const svgImagePath = "assets/" + imageName;

    //     // Check if the image is an SVG
    //     if (svgImagePath.endsWith('.svg')) {
    //         // Fetch and reload only the SVG
    //         this.fetchInteriorImageLoop(svgImagePath);
    //         // Optionally, redraw or update the SVG as needed
    //         // this.redraw();
    //     }
    // };
    resetItems() {
        const imageName = this.images[this.activeImage - 1].getAttribute('src').replace('.jpg', '.svg').split("/assets/").pop()
        Object.keys(this.imagesWithVisible).sort().map((id, index) => {
            if (id.includes('-color') > 0) {
                return
            }
            if (id.includes('-select') > 0) {
                return
            }

            this.imagesWithVisible[id] = false
            if (this.stage.find('.' + id).length === 0) {
                return
            }
            this.stage.find('.' + id)[0].visible(false)
        })
    }
    redraw() {
        try {
            let p1 = this.ctx.transformedPoint(0, 0);
            let p2 = this.ctx.transformedPoint(this.canvas.width, this.canvas.height)
            let hRatio = this.canvas.width / this.currentCanvasImage.width
            let vRatio = this.canvas.height / this.currentCanvasImage.height
            let ratio = Math.min(hRatio, vRatio);
            let centerShift_x = (this.canvas.width - this.currentCanvasImage.width * ratio) / 2
            let centerShift_y = (this.canvas.height - this.currentCanvasImage.height * ratio) / 2
            this.ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);
            this.centerX = this.currentCanvasImage.width * ratio / 2
            this.centerY = this.currentCanvasImage.height * ratio / 2
            //center image
            const tmpImage = new Konva.Image({
                image: this.currentCanvasImage,
                x: this.currentLeftPosition,
                y: this.currentTopPosition,
                name: 'image'
            });

            this.layer1.destroyChildren()
            this.layer1.add(tmpImage)

            const self = this
            const imageName = this.images[this.activeImage - 1].getAttribute('src').replace('.jpg', '.svg').split("/assets/").pop()
            Object.keys(this.imagesWithVisible).sort().map((id, index) => {
                if (this.imagesWithID[imageName][id]) {
                    if (id.includes('-color') > 0) {
                        return
                    }
                    const kPath = new Konva.Path({
                        x: this.currentLeftPosition,
                        y: this.currentTopPosition,
                        data: this.imagesWithID[imageName][id],
                        name: id,
                        draggable: false
                    })
                    this.imagesWithVisible[id + '-overlay'] = false
                    kPath.on('mousedown touchstart', function (ex) {
                        self.resetCurrentSelection()
                        let id = ex.target.getName()
                        if (self.props.onclickHandler !== undefined) {
                            self.imagesWithVisible[id + '-select'] = true
                            self.props.onclickHandler(id)
                            self.redrawItem(ex.target)
                        }
                    });
                    kPath.on('mouseover', function (ex) {
                        let id = ex.target.getName()
                        self.imagesWithVisible[id + '-overlay'] = true
                        self.redrawItem(ex.target)
                    });
                    kPath.on('mouseout', function (ex) {
                        let id = ex.target.getName()
                        self.imagesWithVisible[id + '-overlay'] = false
                        self.redrawItem(ex.target)
                    });
                    self.layer1.add(kPath)
                    self.redrawItem(kPath)
                }
            })
            if (!this.isActivated) {
                this.isActivated = true
                if (this.props.loadData !== undefined) {
                    this.props.loadData()
                }
            }
            // this.layer1.batchDraw()
        }
        catch (e) {
            this.trackTransforms(this.ctx)
        }
    }
    resetCurrentSelection() {
        Object.keys(this.imagesWithVisible).sort().map((id, index) => {
            if (this.imagesWithVisible[id + '-select']) {
                this.imagesWithVisible[id + '-select'] = false
            }
            if (this.imagesWithVisible[id + '-overlay']) {
                this.imagesWithVisible[id + '-overlay'] = false
            }
            let item = this.layer1.find('.' + id)
            if (item.length > 0) {
                this.redrawItem(item[0])
            }
        })
    }
    redrawItem(item) {
        if (item == undefined) {
            return
        }
        let id = item.getName()
        var attrs = item.getAttrs()

        attrs['opacity'] = this.imagesWithVisible[id + '-coloro']
        // attrs['stroke'] = this.imagesWithVisible[id + '-colorStroke']
        // attrs['strokeWidth'] = this.imagesWithVisible[id + '-colorWidth']
        item.visible(this.imagesWithVisible[id])
        if (this.imagesWithVisible[id + '-select']) {
            attrs['fill'] = '#00B8FF'
        } else if (this.imagesWithVisible[id + '-overlay']) {
            attrs['fill'] = '#00B8FF'
        } else {
            attrs['fill'] =
                this.imagesWithVisible[id + '-color'];
        }
        item.setAttrs(attrs)
        this.layer1.clearBeforeDraw(false)
        item.draw()
        this.layer1.clearBeforeDraw(true)

    }
    trackTransforms(ctx) {
        return new Promise(resolve => {
            var svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
            var xform = svg.createSVGMatrix();
            this.ctx.getTransform = function () { return xform; };

            var savedTransforms = [];
            var save = ctx.save;
            this.ctx.save = () => {
                savedTransforms.push(xform.translate(0, 0));
                return save.call(this.ctx);
            };
            var restore = ctx.restore;
            this.ctx.restore = () => {
                xform = savedTransforms.pop();
                return restore.call(this.ctx);
            };
            var scale = this.ctx.scale;
            this.ctx.scale = (sx, sy) => {
                xform = xform.scaleNonUniform(sx, sy);
                return scale.call(this.ctx, sx, sy);
            };
            var rotate = this.ctx.rotate;
            this.ctx.rotate = (radians) => {
                xform = xform.rotate(radians * 180 / Math.PI);
                return rotate.call(this.ctx, radians);
            };
            var translate = this.ctx.translate;
            this.ctx.translate = (dx, dy) => {
                xform = xform.translate(dx, dy);
                return translate.call(this.ctx, dx, dy);
            };
            var transform = this.ctx.transform;
            this.ctx.transform = (a, b, c, d, e, f) => {
                var m2 = svg.createSVGMatrix();
                m2.a = a; m2.b = b; m2.c = c; m2.d = d; m2.e = e; m2.f = f;
                xform = xform.multiply(m2);
                return transform.call(this.ctx, a, b, c, d, e, f);
            };
            var setTransform = this.ctx.setTransform;
            this.ctx.setTransform = (a, b, c, d, e, f) => {
                xform.a = a;
                xform.b = b;
                xform.c = c;
                xform.d = d;
                xform.e = e;
                xform.f = f;
                return setTransform.call(this.ctx, a, b, c, d, e, f);
            };
            var pt = svg.createSVGPoint();
            this.ctx.transformedPoint = (x, y) => {
                pt.x = x; pt.y = y;
                return pt.matrixTransform(xform.inverse());
            }
            resolve(this.ctx)
        })

    }

    prev = (e) => {
        (this.props.spinReverse) ? this.turnRight() : this.turnLeft()
    }

    next = (e) => {
        (this.props.spinReverse) ? this.turnLeft() : this.turnRight()
    }

    resetPosition = () => {
        this.currentScale = 1
        this.activeImage = 1
        this.setImage(true)
    }

    turnLeft() {
        this.moveActiveIndexDown(1);
    }

    turnRight() {
        this.moveActiveIndexUp(1);
    }

    moveActiveIndexUp(itemsSkipped) {
        if (this.stopAtEdges) {
            if (this.activeImage + itemsSkipped >= this.props.amount) {
                this.activeImage = this.props.amount;
            } else {
                this.activeImage += itemsSkipped;
            }
        } else {
            this.activeImage = (this.activeImage + itemsSkipped) % this.props.amount || this.props.amount;
        }

        this.update()
    }

    moveActiveIndexDown(itemsSkipped) {
        if (this.stopAtEdges) {
            if (this.activeImage - itemsSkipped <= 1) {
                this.activeImage = 1;
            } else {
                this.activeImage -= itemsSkipped;
            }
        } else {
            if (this.activeImage - itemsSkipped < 1) {
                this.activeImage = this.props.amount + (this.activeImage - itemsSkipped);
            } else {
                this.activeImage -= itemsSkipped;
            }
        }

        this.update()
    }

    update() {
        const image = this.images[this.activeImage - 1];
        this.currentCanvasImage = image
        this.redraw()
    }

    zoomImage = (evt) => {
        this.setState({
            lastX: evt.offsetX || (evt.pageX - this.canvas.offsetLeft),
            lastY: evt.offsetY || (evt.pageY - this.canvas.offsetTop)
        })

        var delta = evt.wheelDelta ? evt.wheelDelta / 40 : evt.deltaY ? -evt.deltaY : 0;

        if (delta) this.zoom(delta);
        //return evt.preventDefault() && false;

    }

    zoomIn = (evt) => {
        this.setState({
            lastX: this.centerX,
            lastY: this.centerY
        })
        //this.lastY = this.centerY
        this.zoom(2)
    }
    zoomOut = (evt) => {
        this.setState({
            lastX: this.centerX,
            lastY: this.centerY
        })
        this.zoom(-2)
    }

    zoom(clicks) {
        let factor = Math.pow(1.01, clicks);
        if (factor > 1) {
            this.currentScale += factor
        } else {
            if (this.currentScale - factor > 1)
                this.currentScale -= factor
            else
                this.currentScale = 1
        }

        if (this.currentScale > 1) {
            let pt = this.ctx.transformedPoint(this.state.lastX, this.state.lastY);
            this.ctx.translate(pt.x, pt.y);
            this.ctx.scale(factor, factor);
            this.ctx.translate(-pt.x, -pt.y);
            this.redraw();
        }
    }

    disableZoomin() {
        document.addEventListener("gesturestart", function (e) {
            e.preventDefault();
            document.body.style.zoom = 0.99;
        });
        document.addEventListener("gesturechange", function (e) {
            e.preventDefault();
            document.body.style.zoom = 0.99;
        });

        document.addEventListener("gestureend", function (e) {
            e.preventDefault();
            document.body.style.zoom = 1;
        });
    }


    onMove(pageX) {
        if (pageX - this.movementStart >= this.speedFactor) {
            let itemsSkippedRight = Math.floor((pageX - this.movementStart) / this.speedFactor) || 1;

            this.movementStart = pageX;
            if (this.props.spinReverse) {
                this.moveActiveIndexDown(itemsSkippedRight);
            } else {
                this.moveActiveIndexUp(itemsSkippedRight);
            }
            this.redraw();
        } else if (this.movementStart - pageX >= this.speedFactor) {
            let itemsSkippedLeft = Math.floor((this.movementStart - pageX) / this.speedFactor) || 1;

            this.movementStart = pageX;
            if (this.props.spinReverse) {
                this.moveActiveIndexUp(itemsSkippedLeft);
            } else {
                this.moveActiveIndexDown(itemsSkippedLeft);
            }
            this.redraw();
        }
    }

    startMoving = (evt) => {
        this.movement = true
        this.movementStart = evt.pageX;
        this.viewPortElementRef.style.cursor = 'grabbing';
    }

    doMoving = (event) => {
        if (this.movement) {
            this.onMove(event.clientX)
        }

    }

    stopMoving = (evt) => {
        this.movement = false
        this.movementStart = 0
        this.viewPortElementRef.style.cursor = 'grab'
    }

    touchStart = (evt) => {
        this.movementStart = evt.touches[0].clientX
    }

    touchMove = (evt) => {
        this.onMove(evt.touches[0].clientX)
    }

    touchEnd = () => {
        this.movementStart = 0
    }

    play = (e) => {
        this.setState({
            loopTimeoutId: window.setInterval(() => this.loopImages(), 100)
        })
    }

    onSpin() {
        if (this.state.playing || this.state.loopTimeoutId) {
            this.stop();
        }
    }

    stop() {
        if (this.activeImage === 1) {
            this.setState({ currentLoop: 0 })
        }
        this.setState({ playing: false })
        window.clearTimeout(this.state.loopTimeoutId);
    }

    loopImages() {
        let loop = (this.props.loop) ? this.props.loop : 1

        if (this.activeImage === 1) {
            if (this.state.currentLoop === loop) {
                this.stop()
            }
            else {
                this.setState({ currentLoop: this.state.currentLoop + 1 })

                this.next()
            }
        }
        else {
            this.next()
        }
    }

    togglePlay = (e) => {
        this.setState({ playing: !this.state.playing })
    }

    togglePanMode = (e) => {
        this.setState({ panmode: !this.state.panmode })
    }

    toggleFullScreen = (e) => {
        this.setState({ isFullScreen: !this.state.isFullScreen })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.currentLeftPosition !== prevState.currentLeftPosition) {
            this.redraw();
        }

        if (this.state.panmode !== prevState.panmode) {
            this.attachEvents()
        }

        if (this.state.playing !== prevState.playing) {
            if (!this.state.playing) {
                this.stop()
            } else {
                this.play()
            }
        }

        if (this.state.isFullScreen !== prevState.isFullScreen) {
            if (!this.state.isFullScreen) {
                //exit full screen
                this.viewerContainerRef.classList.remove('v360-main')
                this.viewerContainerRef.classList.remove('v360-fullscreen')
            } else {
                //enter full screen
                this.viewerContainerRef.classList.add('v360-main')
                this.viewerContainerRef.classList.add('v360-fullscreen')

            }
            this.setImage()
        }
    }

    handlePinch = (e) => {
        if (e.scale < this.currentScale) {
            // zoom in
            this.zoomIn();
        } else if (e.scale > this.currentScale) {
            // zoom out
            this.zoomOut();
        }

        //lastScale = e.scale;
    }

    pinchOut = () => {
        this.currentScale = 1
    }


    calculatePos = () => {
        var canvasZoom = this.canvas.getZoom();
    }

    render() {

        return (

            <div>
                <div id='parent-selector' className="v360-viewer-container" ref={(inputEl) => { this.viewerContainerRef = inputEl }} id="identifier" onWheel={(e) => this.zoomImage(e)}>

                    {!this.state.imagesLoaded ?
                        <div className="v360-viewport">
                            <div className="v360-spinner-grow"></div>
                            <p ref={this.viewPercentageRef} className="v360-percentage-text"></p>
                        </div> : ''}


                    <Hammer onPinchIn={this.handlePinch} onPinchOut={this.handlePinch} onPinchEnd={this.pinchOut}
                        options={{
                            recognizers: {
                                pinch: { enable: true }
                            }
                        }}>
                        <div id='canvas1' className="v360-viewport-container ">
                            <canvas
                                ref={(inputEl) => { this.imageContainerRef = inputEl }}
                            />
                            {this.props.boxShadow ? <div className="v360-product-box-shadow"></div> : ''}

                        </div>
                    </Hammer>

                    <abbr title="Fullscreen Toggle">
                        <div className="v360-fullscreen-toggle text-center" onClick={this.toggleFullScreen}>
                            <div className={this.props.buttonClass === 'dark' ? 'v360-fullscreen-toggle-btn text-light' : 'v360-fullscreen-toggle-btn text-dark'}>
                                <i className={!this.state.isFullScreen ? 'fas fa-expand text-lg' : 'fas fa-compress text-lg'}></i>
                            </div>
                        </div>
                    </abbr>

                    <div id="v360-menu-btns" className={this.props.buttonClass}>
                        <div className="v360-navigate-btns">
                            <Button
                                clicked={this.togglePlay}
                                icon={this.state.playing ? 'fa fa-pause' : 'fa fa-play'}
                            />
                            <Button
                                clicked={this.zoomIn}
                                icon="fa fa-search-plus"
                            />
                            <Button
                                clicked={this.zoomOut}
                                icon="fa fa-search-minus"
                            />


                            <Button
                                clicked={this.prev}
                                icon="fa fa-chevron-left"
                            />
                            <Button
                                clicked={this.next}
                                icon="fa fa-chevron-right"
                            />
                            <Button
                                clicked={this.resetPosition}
                                icon="fa fa-sync"
                            />
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default ReactKrishViewer;